import React, { useState, useEffect } from "react";
import { Dropdown } from "semantic-ui-react";
import ReadAxios from "../axiosComponent/read";
import CreateAxios from "../axiosComponent/create";
import allAxiosCommonRequest from '../axiosComponent/allAxiosCommonRequest';

const ShippingLine = ({
  field: { name },
  form: { setFieldValue },
  fillAddressState,
  ...props
}) => {
  const [ShippingLine, setShippingLine] = useState([]);
  const [isloading, setisloading] = useState(false);
  useEffect(() => {
    allAxiosCommonRequest({url : 'masters/shippingLine', method: 'get'})
    .then((response)=>{
        setShippingLine(response.data.resultSet);
    })
    .catch((error) => console.log(error));
}, []);


  let shippingLineOptions = [];
  if (ShippingLine.length > 0) {
    ShippingLine.map((object, index) => {
      let temp = {};
      temp.key = object.shippingLineId;
      temp.text = object.shippingLine;
      temp.value = object.shippingLineId;
      temp.raw = { ...object };
      return (shippingLineOptions[index] = temp);
    });
  }

  let handleChange = (value, data) => {
    setFieldValue(name, data.value);
    if (props?.placeholderName) {
      let selected = data.options.filter((object, index) => {
        if (object.value == data.value) {
          return object.text
        }
      });
      setFieldValue(props.placeholderName, selected[0]?.text);
    }
  };
  return (
    <div className="">
      <Dropdown
        selection
        clearable
        loading={isloading ? true : false}
        placeholder={props.placeholder}
        style={{ width: "100%" }}
        onChange={handleChange}
        options={shippingLineOptions}
        {...props}
      />
    </div>
  );
};

export default ShippingLine;
